export const MENU_ID = 'menu-icon';
export const USER_ID = 'user-icon';
export const SHOPPING_ID = 'shopping-icon';
export const SUBSCRIBE_ID = 'subscribe-icon';
export const SEARCH_ID = 'search-icon';